import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

type NamedModule = Record<string, unknown>;

export const lazyNamedExport = <TProps extends object = Record<string, never>>(
  importer: () => Promise<NamedModule>,
  exportName: string,
): LazyExoticComponent<ComponentType<TProps>> =>
  lazy(async () => {
    const module = await importer();
    return { default: module[exportName] as ComponentType<TProps> };
  });
